import axios from "axios";
import { API } from "../../../api/api";

export const getHomepage = () =>
  axios.get(API.url + "/homepage?populate[Leistungen][populate]=*&populate[logos][populate]=*&populate[HeroImages][populate]=*&populate[SoftwareImage1][populate]=*&populate[SoftwareImage2][populate]=*&populate[SoftwareShorts][populate]=*&populate[Advantages][populate]=*").then((res) => res.data.data.attributes);

export const getHowWeOperate = async () =>
  await axios.get(API.url + "/how-we-operates").then((res) => res.data.data);

export const getHomepageData = () =>
  axios.get(API.url + "/homepage-new?populate[hero][populate]=*&populate[solutions][populate]=*&populate[leftSide][populate]=*&populate[rightSide][populate]=*&populate[projectSelection][populate]=*&populate[customers][populate]=*&populate[headingProcess][populate]=*&populate[projects][populate]=*").then((res) => res.data.data.attributes);
